import { createContext, useContext } from "react";

export type TemplatePickerApi = { open: () => void; close: () => void; isOpen: boolean };

export const TemplatePickerContext = createContext<TemplatePickerApi>({
  open: () => {},
  close: () => {},
  isOpen: false,
});

export function useTemplatePicker(): TemplatePickerApi {
  return useContext(TemplatePickerContext);
}
